import React from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
const CareerCard = ({ icon, title, details, detailData }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleDetailsClick = () => {
  
    navigate("/career-details", {
      state: detailData,
    });
  };

  return (
    <div className="col-md-3 col-sm-4 mb-4">
      <div className="card h-100 shadow-sm">
        <div className="text-center mt-4" style={{ fontSize: "3rem" }}>
          {icon}
        </div>
        <div className="card-body d-flex flex-column p-4">
          <h4 className="card-title text-center font-weight-bold">{title}</h4>
          <ul className="text-start list-unstyled mt-3">
            {details.map((point, index) => (
              <li key={index}>• {point}</li>
            ))}
          </ul>
          <div className="mt-auto text-center">
            <button className="btn btn-primary blue-color-code" onClick={handleDetailsClick}>
            {t("more_details_button")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareerCard;
